export default __webpack_public_path__ + "static/media/netcarbs@3x.6d1cdeeb.jpg";